import { 
  DEVICE_LIST_LOADING,
  DEVICE_LIST_SUCCESS,
  DEVICE_LIST_ERROR,

  DEVICE_DELETE_LOADING,
  DEVICE_DELETE_SUCCESS,
  DEVICE_DELETE_ERROR,

  FETCH_DEVICE_FILTER_VALUES_LOADING,
  FETCH_DEVICE_FILTER_VALUES_SUCCESS,
  FETCH_DEVICE_FILTER_VALUES_ERROR,

  FETCH_DEVICE_BY_ID_LOADING,
  FETCH_DEVICE_BY_ID_SUCCESS,
  FETCH_DEVICE_BY_ID_ERROR,
  RESTE_DEVICE_DETAILS,

  // new dropdown constants
  FETCH_CUSTOMER_DROPDOWN_LOADING,
  FETCH_CUSTOMER_DROPDOWN_SUCCESS,
  FETCH_CUSTOMER_DROPDOWN_ERROR,

  FETCH_BUILDING_DROPDOWN_LOADING,
  FETCH_BUILDING_DROPDOWN_SUCCESS,
  FETCH_BUILDING_DROPDOWN_ERROR,

  FETCH_FLOOR_DROPDOWN_LOADING,
  FETCH_FLOOR_DROPDOWN_SUCCESS,
  FETCH_FLOOR_DROPDOWN_ERROR,

  FETCH_DEVICE_TYPE_DROPDOWN_LOADING,
  FETCH_DEVICE_TYPE_DROPDOWN_SUCCESS,
  FETCH_DEVICE_TYPE_DROPDOWN_ERROR,
      DOWNLOAD_LIST_SUCCESS

} from "../Actions/DeviceComponent";


const initialState = {
  deviceListLoading: false,
  deviceListSuccess: null,
  deviceListError: null,
  
  deviceDeleteLoading: false,
  deviceDeleteSuccess: false,
  deviceDeleteError: null,

  deviceFiltersLoading: false,
  deviceFiltersSuccess: {
    floors: [],
    deviceType: []
  },
  deviceFiltersError: null,

  deviceDetailsLoading: false,
  deviceDetailsSuccess: null,
  deviceDetailsError: null,
  downloadguideFile:false,
  // dropdowns
  customerDropdownLoading: false,
  customerDropdownSuccess: null,
  customerDropdownError: null,

  buildingDropdownLoading: false,
  buildingDropdownSuccess: null,
  buildingDropdownError: null,

  floorDropdownLoading: false,
  floorDropdownSuccess: null,
  floorDropdownError: null,

  deviceTypeDropdownLoading: false,
  deviceTypeDropdownSuccess: null,
  deviceTypeDropdownError: null,
};


const DeviceComponentReducer = (state = initialState, action) => {
  switch (action.type) {
    // ---------------- Devices ----------------
    case DEVICE_LIST_LOADING:
      return { ...state, deviceListLoading: true, deviceListError: null };
    case DEVICE_LIST_SUCCESS:
      return { ...state, deviceListLoading: false, deviceListSuccess: action.payload };
    case DEVICE_LIST_ERROR:
      return { ...state, deviceListLoading: false, deviceListError: action.payload };

    case DEVICE_DELETE_LOADING:
      return { ...state, deviceDeleteLoading: true, deviceDeleteError: null };
    case DEVICE_DELETE_SUCCESS:
      return { ...state, deviceDeleteLoading: false, deviceDeleteSuccess: true };
      case DOWNLOAD_LIST_SUCCESS:
        return{
            ...state,
            downloadguideFile:true
        };
    case DEVICE_DELETE_ERROR:
      return { ...state, deviceDeleteLoading: false, deviceDeleteError: action.payload };

    // ---------------- Filter Values ----------------
    case FETCH_DEVICE_FILTER_VALUES_LOADING:
      return { ...state, deviceFiltersLoading: true, deviceFiltersSuccess: null };
    case FETCH_DEVICE_FILTER_VALUES_SUCCESS:
      return {
        ...state,
        deviceFiltersLoading: false,
        deviceFiltersSuccess: {
          floors: action.payload.floors,
          deviceType: action.payload.deviceType,
          customerData: action.payload.customerData,
        },
      };
    case FETCH_DEVICE_FILTER_VALUES_ERROR:
      return { ...state, deviceFiltersLoading: false, deviceFiltersError: action.payload };

    // ---------------- Device by ID ----------------
    case FETCH_DEVICE_BY_ID_LOADING:
      return { ...state, deviceDetailsLoading: true, deviceDetailsSuccess: null, deviceDetailsError: null };
    case FETCH_DEVICE_BY_ID_SUCCESS:
      return { ...state, deviceDetailsLoading: false, deviceDetailsSuccess: action.payload, deviceDetailsError: null };
    case FETCH_DEVICE_BY_ID_ERROR:
      return { ...state, deviceDetailsLoading: false, deviceDetailsSuccess: null, deviceDetailsError: action.payload };
    case RESTE_DEVICE_DETAILS: 
      return { ...state, deviceDetailsLoading: false, deviceDetailsSuccess: null, deviceDetailsError: null };

    // ---------------- Customer Dropdown ----------------
    case FETCH_CUSTOMER_DROPDOWN_LOADING:
      return { ...state, customerDropdownLoading: true, customerDropdownError: null };
    case FETCH_CUSTOMER_DROPDOWN_SUCCESS:
      return { ...state, customerDropdownLoading: false, customerDropdownSuccess: action.payload };
    case FETCH_CUSTOMER_DROPDOWN_ERROR:
      return { ...state, customerDropdownLoading: false, customerDropdownError: action.payload };

    // ---------------- Building Dropdown ----------------
    case FETCH_BUILDING_DROPDOWN_LOADING:
      return { ...state, buildingDropdownLoading: true, buildingDropdownError: null };
    case FETCH_BUILDING_DROPDOWN_SUCCESS:
      return { ...state, buildingDropdownLoading: false, buildingDropdownSuccess: action.payload };
    case FETCH_BUILDING_DROPDOWN_ERROR:
      return { ...state, buildingDropdownLoading: false, buildingDropdownError: action.payload };

    // ---------------- Floor Dropdown ----------------
    case FETCH_FLOOR_DROPDOWN_LOADING:
      return { ...state, floorDropdownLoading: true, floorDropdownError: null };
    case FETCH_FLOOR_DROPDOWN_SUCCESS:
      return { ...state, floorDropdownLoading: false, floorDropdownSuccess: action.payload };
    case FETCH_FLOOR_DROPDOWN_ERROR:
      return { ...state, floorDropdownLoading: false, floorDropdownError: action.payload };

    // ---------------- DeviceType Dropdown ----------------
    case FETCH_DEVICE_TYPE_DROPDOWN_LOADING:
      return { ...state, deviceTypeDropdownLoading: true, deviceTypeDropdownError: null };
    case FETCH_DEVICE_TYPE_DROPDOWN_SUCCESS:
      return { ...state, deviceTypeDropdownLoading: false, deviceTypeDropdownSuccess: action.payload };
    case FETCH_DEVICE_TYPE_DROPDOWN_ERROR:
      return { ...state, deviceTypeDropdownLoading: false, deviceTypeDropdownError: action.payload };

    // ---------------- Reset ----------------
    case "RESET_DEVICE_STATE":
      return initialState;

    default:
      return state;
  }
};

export default DeviceComponentReducer;
